import * as React from "react";
const SvgFiRrFeather = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-feather_svg__a)">
      <path
        fill="#062147"
        d="M22.827 1.174A3.97 3.97 0 0 0 19.04.119a31.3 31.3 0 0 0-13.784 7.75A7.76 7.76 0 0 0 3.009 13.7c.071 1.56.619 3.06 1.569 4.3L.293 22.293a1 1 0 1 0 1.414 1.414l4.284-4.284A7.45 7.45 0 0 0 10.589 21a8.4 8.4 0 0 0 5.9-2.545c4.4-4.4 6.883-11.446 7.394-13.525a3.93 3.93 0 0 0-1.056-3.756M5.007 13.608a5.76 5.76 0 0 1 1.665-4.327C7.1 8.856 7.545 8.457 8 8.067v6.519l-1.99 1.99a5.67 5.67 0 0 1-1.003-2.968m10.038 3.459a5.91 5.91 0 0 1-7.618.92l2.279-2.279L12.414 13h5.762a25.8 25.8 0 0 1-3.131 4.067m6.9-12.62a29.6 29.6 0 0 1-2.6 6.553h-4.931l3.293-3.293a1 1 0 1 0-1.414-1.414l-5 5L10 12.586V6.512a30.4 30.4 0 0 1 9.522-4.451q.238-.06.484-.061a2 2 0 0 1 1.409.589 1.93 1.93 0 0 1 .526 1.858z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-feather_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFeather;
